import { useCallback, useContext } from 'react';
import { Farm } from 'app/agriculture/contexts/RequiredStartupProviders/FarmContext/farmSchema';
import { ServicesContext } from 'app/items/shared/context_interface';

export function useFlyToFarm() {
    const { mapService } = useContext(ServicesContext);
    const flyToFarm = useCallback(
        ({
            center,
            viewRotation,
            viewAngle,
            viewHeight,
        }: Pick<Farm, 'center' | 'viewRotation' | 'viewAngle' | 'viewHeight'>) => {
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!mapService.viewer) return;
            mapService.viewer.camera.flyTo({
                destination: Cesium.Cartesian3.fromDegrees(
                    center.coordinates[0],
                    center.coordinates[1],
                    viewHeight,
                ),
                orientation: {
                    heading: Cesium.Math.toRadians(viewRotation),
                    pitch: Cesium.Math.toRadians(viewAngle),
                    roll: 0.0,
                },
            });
        },
        [mapService.viewer],
    );
    return { flyToFarm };
}
